import React, { useState, useEffect, useCallback } from "react";
import Edit from "../icons/edit.svg";

const PreviewwBar = () => {
  const [message, setMessage] = useState("");
  const [loadedEdit, setLoadedEdit] = useState(false);
  const [edit, setEdit] = useState(false);
  const toggleEdit = useCallback(() => setEdit((value) => !value), []);

  useEffect(() => {
    if (!loadedEdit) {
      const savedEdit = window.sessionStorage.getItem("development-preview-edit");
      setEdit(savedEdit === "true");
      setLoadedEdit(true);
    }
  }, [loadedEdit]);

  const refresh = useCallback(async (sources) => {
    const response = await fetch("/__refresh", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ sources: [sources] }),
    });

    if (response.status !== 200) {
      setMessage(`Refresh non disponbile ${response.status}`);
    }
  }, []);

  useEffect(() => {
    const event = new CustomEvent("development-preview-edit", {
      detail: {
        enabled: edit,
      },
    });
    document.dispatchEvent(event);
    window.sessionStorage.setItem("development-preview-edit", edit);
  }, [edit]);

  return (
    <div id="development-preview-bar" className="preview-bar d-flex align-items-center">
      <button
        onClick={() => refresh("liferay")}
        type="submit"
        className="btn-link btn-link--white my-1 ml-1"
      >
        Refresh Liferay
      </button>
      <button
        onClick={() => refresh("babel")}
        type="submit"
        className="btn-link btn-link--white my-1 ml-3 mr-2"
      >
        Refresh Babel
      </button>
      <span>{message}</span>
      <button
        onClick={toggleEdit}
        className={`preview-bar__edit ml-1 d-inline-flex justifuy-content-center align-items-center ${
          edit ? " preview-bar__edit--enabled" : ""
        }`}
      >
        <Edit />
      </button>
    </div>
  );
};

export default PreviewwBar;
